import axios, { AxiosResponse } from 'axios' 
import { IServiceTariffModel } from './ServiceTariffModel'
import { ApiResponse, PageResponse } from '../../../../shared/models/ApiModels'


const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const SERVICETARIFF_CREATE_URL = `${API_URL}api/v1/definition/insuranceRate/create`
export const SERVICETARIFF_GET_ALL_URL = `${API_URL}api/v1/definition/insuranceRate/all`
export const SERVICETARIFF_DELETE_URL = `${API_URL}api/v1/definition/insuranceRate/delete/`
export const SERVICETARIFF_UPDATE_URL = `${API_URL}api/v1/definition/insuranceRate/update/`

export function createServiceTariff(serviceTariff: IServiceTariffModel) {
  return axios.post(SERVICETARIFF_CREATE_URL, serviceTariff)
}

export async function loadServiceTariffs(
  page = 0, 
  size = 5, 
  sort: string = 'createdDate', 
  order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<IServiceTariffModel>>>> {
  return axios.get(SERVICETARIFF_GET_ALL_URL, {
    params: { page, size, sort, order }
  });
}

export function deleteServiceTariff(serviceTariffId: String) {
  return axios.delete(SERVICETARIFF_DELETE_URL + serviceTariffId)
}

export function updateServiceTariff(serviceTariff: IServiceTariffModel) {
  return axios.patch(SERVICETARIFF_UPDATE_URL + serviceTariff.id, serviceTariff)
}